import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";

function BuscarPartidoResultCard({ busqueda, getResultadoFromPartido, getEtapaFromPartido }) {
    const resultadoPartido = getResultadoFromPartido(busqueda);
    const primerEsAguada = busqueda.local;
    const primerScore = primerEsAguada ? resultadoPartido.scoreAguada : resultadoPartido.scoreRival;
    const segundoScore = primerEsAguada ? resultadoPartido.scoreRival : resultadoPartido.scoreAguada;
    const claseAguada = busqueda.ganado ? 'text-green-400 text-2xl sm:text-3xl font-black' : 'text-red-400 text-xl sm:text-2xl font-bold';
    const claseRival = busqueda.ganado ? 'text-slate-300 text-xl sm:text-2xl font-bold' : 'text-slate-300 text-2xl sm:text-3xl font-black';

    return (
        <div className={`bg-white/5 backdrop-blur-xl border border-white/20 rounded-xl p-3 sm:p-5 flex flex-col gap-3 sm:gap-4 md:gap-6 md:flex-row md:items-center md:justify-between ${busqueda.ganado ? 'hover:border-green-500/40' : 'hover:border-red-500/40'} transition-all`}>
            {/* Top row on mobile: date + info | score */}
            <div className="flex items-center justify-between md:justify-start gap-3 sm:gap-6 md:gap-10">
                <div className="flex items-center gap-3 sm:gap-6 md:gap-10 min-w-0">
                    <div className="text-center shrink-0 w-12 sm:w-16">
                        {moment(busqueda.fecha).isValid() ? (
                            <>
                                <p className="text-[10px] sm:text-xs font-bold text-slate-400 uppercase">{moment(busqueda.fecha).format('MMM DD').replace('.', '')}</p>
                                <p className="text-base sm:text-xl font-extrabold text-white">{moment(busqueda.fecha).format('YYYY')}</p>
                            </>
                        ) : (
                            <p className="text-base sm:text-xl font-extrabold text-slate-400 leading-tight">SIN FECHA</p>
                        )}
                    </div>
                    <div className="h-10 sm:h-12 w-[2px] bg-green-500/30 hidden sm:block"></div>
                    <div className="min-w-0">
                        <p className={`text-[10px] sm:text-xs font-bold uppercase ${busqueda.ganado ? 'text-green-400' : 'text-red-400'}`}>{resultadoPartido.label}</p>
                        <h3 className="text-sm sm:text-xl font-bold text-white truncate">vs {busqueda.adversario}</h3>
                        <p className="text-[10px] sm:text-xs text-slate-400 truncate">{busqueda.cancha} ({busqueda.local ? 'L' : 'V'})</p>
                        <p className="text-[10px] sm:text-xs text-slate-500 mt-0.5 sm:mt-1 truncate">{busqueda.liga} · {getEtapaFromPartido(busqueda)}</p>
                    </div>
                </div>

                {/* Score - visible on mobile inline */}
                <div className="text-right shrink-0 md:hidden">
                    <div className="flex items-baseline gap-1.5">
                        <span className={primerEsAguada ? claseAguada : claseRival}>{primerScore}</span>
                        <span className="text-slate-500 text-lg font-medium">-</span>
                        <span className={primerEsAguada ? claseRival : claseAguada}>{segundoScore}</span>
                    </div>
                    {busqueda.alargues?.length > 0 && <p className="text-[10px] text-slate-500 mt-0.5">Alargue en {busqueda.alargues.join(', ')}</p>}
                </div>
            </div>

            {/* Bottom row on mobile: button full width */}
            <div className="flex items-center justify-between md:justify-end gap-4 sm:gap-8 md:gap-10">
                {/* Score - desktop only */}
                <div className="text-right hidden md:block">
                    <div className="flex items-baseline gap-2">
                        <span className={primerEsAguada ? claseAguada : claseRival}>{primerScore}</span>
                        <span className="text-slate-500 text-xl font-medium">-</span>
                        <span className={primerEsAguada ? claseRival : claseAguada}>{segundoScore}</span>
                    </div>
                    {busqueda.alargues?.length > 0 && <p className="text-[11px] text-slate-500 mt-1">Alargue en {busqueda.alargues.join(', ')}</p>}
                </div>
                <Link to={`/partido/${busqueda._id}`} className="w-full md:w-auto">
                    <button className="w-full md:w-auto flex items-center justify-center gap-2 px-4 py-2 bg-green-500/10 text-green-400 border border-green-500/20 rounded-lg font-bold text-xs sm:text-sm hover:bg-green-500 hover:text-black transition-all">
                        Estadísticas
                    </button>
                </Link>
            </div>
        </div>
    );
}

export default BuscarPartidoResultCard;
